module.exports = __webpack_public_path__ + "static/img/10.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/10.png
// module id = A1Ub
// module chunks = 0